import { render, staticRenderFns } from "./lightBeam.vue?vue&type=template&id=269d17a6&scoped=true&"
import script from "./lightBeam.vue?vue&type=script&lang=js&"
export * from "./lightBeam.vue?vue&type=script&lang=js&"
import style0 from "./lightBeam.vue?vue&type=style&index=0&id=269d17a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269d17a6",
  null
  
)

export default component.exports